import React from 'react';
import { useMissionStore } from '../stores/missionStore';
import { factions } from '@bid/bitd-data';

export const FactionSelector: React.FC = (): JSX.Element => {
  const { primaryFaction, opposingFaction, setPrimaryFaction, setOpposingFaction } =
    useMissionStore();

  const containerStyle: React.CSSProperties = {
    marginBottom: '32px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '24px',
  };

  const formGroupStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '8px',
  };

  const labelStyle: React.CSSProperties = {
    color: '#d4af37',
    fontWeight: 600,
    fontSize: '14px',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
  };

  const selectStyle: React.CSSProperties = {
    width: '100%',
    padding: '12px 16px',
    backgroundColor: '#0f0f1e',
    border: '1px solid rgba(212, 175, 55, 0.2)',
    borderRadius: '8px',
    color: '#e5e7eb',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    outline: 'none',
    appearance: 'none' as const,
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23d4af37' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 12px center',
    backgroundSize: '20px',
    paddingRight: '44px',
  };

  return (
    <div style={containerStyle}>
      <div style={formGroupStyle}>
        <label style={labelStyle}>Primary Faction (Optional)</label>
        <select
          value={primaryFaction || ''}
          onChange={e => setPrimaryFaction(e.target.value || null)}
          style={selectStyle}
          onFocus={e => {
            e.currentTarget.style.borderColor = '#d4af37';
            e.currentTarget.style.boxShadow = '0 0 0 3px rgba(212, 175, 55, 0.1)';
          }}
          onBlur={e => {
            e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.2)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <option value="" style={{ backgroundColor: '#0f0f1e', color: '#9ca3af' }}>
            Select a faction...
          </option>
          {factions.map(faction => (
            <option
              key={faction.name}
              value={faction.name}
              style={{ backgroundColor: '#0f0f1e', color: '#e5e7eb' }}
            >
              {faction.name}
            </option>
          ))}
        </select>
      </div>

      <div style={formGroupStyle}>
        <label style={labelStyle}>Opposing Faction (Optional)</label>
        <select
          value={opposingFaction || ''}
          onChange={e => setOpposingFaction(e.target.value || null)}
          style={selectStyle}
          onFocus={e => {
            e.currentTarget.style.borderColor = '#d4af37';
            e.currentTarget.style.boxShadow = '0 0 0 3px rgba(212, 175, 55, 0.1)';
          }}
          onBlur={e => {
            e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.2)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <option value="" style={{ backgroundColor: '#0f0f1e', color: '#9ca3af' }}>
            Select a faction...
          </option>
          {factions.map(faction => (
            <option
              key={faction.name}
              value={faction.name}
              style={{ backgroundColor: '#0f0f1e', color: '#e5e7eb' }}
            >
              {faction.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
